import { render, staticRenderFns } from "./PerformanceLogsTable.vue?vue&type=template&id=0bcf3124&scoped=true"
import script from "./PerformanceLogsTable.vue?vue&type=script&lang=js"
export * from "./PerformanceLogsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf3124",
  null
  
)

export default component.exports